import Button from "@Components/Button";
import styles from "./ReferralProgramCard.module.scss";
import gtagEventEmitter from "helpers/gtagEventEmitter";
import { PAGE } from "constants/configConstants";
import formatClassNames from "@Utils/clientUtils/stringUtility/formatClassNames";
import Image from "@Components/Image";
import wrapperHOC from "@Utils/wrapperHOC";
import useIsApp from "hooks/useIsApp";
import { sendWebViewEvent } from "@Utils/webviewEvents";
import { useHistory } from "hooks/useHistory";
import { WEB_VIEW_APP_EVENTS } from "@Utils/webApputils/analyticEvents";
import navigateTo from "@Utils/webApputils/navigateTo";
import useCustomWindowOpen from "@Components/CustomWindowOpen";

const ReferralProgramCard = ({
  title,
  subtitle,
  index,
  ctaText,
  href,
  gtagTitle,
  bgSrc,
  isDesktop,
  testId,
  getLocalizedPath = false,
  openInExternalBrowser = false,
}: any) => {
  let backgroundImageClass;
  switch (index) {
    case 2:
      backgroundImageClass = styles.cardInner2;
      break;
    case 3:
      backgroundImageClass = styles.cardInner3;
      break;
    default:
      backgroundImageClass = styles.cardInner1;
      break;
  }
  const isApp = useIsApp();
  const history = useHistory();
  const customWindowOpen = useCustomWindowOpen();
  const handleRedirect = () => {
    gtagEventEmitter({
      action: "clicked_refer_and_offer_card",
      category: PAGE.HOME,
      refer_title: gtagTitle,
    });
    if (isApp) {
      if (openInExternalBrowser) {
        const urlToOpen = `${window.location.origin}${href}`;
        sendWebViewEvent(WEB_VIEW_APP_EVENTS.OPEN_EXTERNAL_URL, { url: urlToOpen });
      } else navigateTo(history, href);
    } else customWindowOpen({ url: href, target: "_blank", isExternal: getLocalizedPath });
  };

  return (
    <div
      className={styles.cardOuter}
      onClick={handleRedirect}
      role="none"
      data-testid="referral-program-card"
    >
      <div
        className={formatClassNames(backgroundImageClass, isDesktop && styles.desktop)}
        data-testid={`referral-program-card-${testId}`}
      >
        <Image
          src={bgSrc}
          height={isDesktop ? 500 : 300}
          width={isDesktop ? 200 : 150}
          alt={title}
        />
        <div className={styles.topSection}>
          <div className={styles.cardTitle}>{title}</div>
          <div className={styles.cardSubTitle}>{subtitle}</div>
        </div>
        <Button
          dataTestId={`amber-refer-offer-section-${testId}-card-${ctaText}-button`}
          variant="primary"
          size="md"
          onClick={handleRedirect}
          className={styles.cta}
        >
          {ctaText}
        </Button>
      </div>
    </div>
  );
};

export default wrapperHOC(ReferralProgramCard, {
  componentName: "ReferralProgramCard-ReferralProgram-Home",
  showForChina: true,
});
